
import FlexiButton from "slotworks/graphics/elements/flexi-button";
abstract class AbstractButtonBehaviour {

    protected button: FlexiButton;
    protected buttonAutoSpin: FlexiButton;
    protected buttonBetMenu: FlexiButton;

    public init() {
        // init
    }

    public destroy() {
        if (this.button) {
            this.button.setVisible(false);

            this.button = null;
        }
		 if (this.buttonAutoSpin) {
            this.buttonAutoSpin.setVisible(false);

            this.buttonAutoSpin = null;
        }
        if (this.buttonBetMenu) {
            this.buttonBetMenu.setVisible(false);

            this.buttonBetMenu = null;
        }
    }
}

export default AbstractButtonBehaviour;



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/abstract-button-behaviour.ts